import React from "react";
import InfoLayout, { Sec } from "@/components/InfoLayout";

export default function Privacy() {
  return (
    <InfoLayout title="Privacy Policy" docTitle="Privacy Policy" subtitle="How CiteQR handles your information.">
      <Sec heading="Information we store">
        <p>For guest-generated static QR codes, we store nothing — codes are created locally in your browser. If you create an account, we store your email, name, optional institution, and the reference pages you choose to save.</p>
      </Sec>
      <Sec heading="What we do not do">
        <ul className="list-disc space-y-1 pl-5">
          <li>We do not sell your personal information.</li>
          <li>We do not place tracking inside guest-generated static QR codes, and reference-page QR codes never redirect through a tracking service.</li>
          <li>We do not require unnecessary personal data.</li>
          <li>We do not knowingly collect protected health information.</li>
        </ul>
      </Sec>
      <Sec heading="Reference page analytics">
        <p>To show authors how their published reference pages are used, CiteQR counts page visits. We do not store IP addresses, device details, or cookies for this. Each visit gets a scrambled visitor code that changes every day and cannot be linked back to a person or across days. QR codes downloaded for reference pages include a small "from QR" marker so scans can be counted; it contains no personal information. Visit records are deleted automatically after 13 months, and visit counts are visible only to the page's author and CiteQR administrators.</p>
      </Sec>
      <Sec heading="Sensitive information">
        <p>Please do not upload confidential, sensitive, or identifiable patient, participant, or student information. CiteQR does not claim HIPAA, FERPA, or GDPR compliance.</p>
      </Sec>
      <Sec heading="Security">
        <p>We use HTTPS throughout the platform and store passwords using accepted one-way hashing. You can delete individual projects or your entire account at any time.</p>
      </Sec>
      <Sec heading="Contact">
        <p>Questions about privacy can be sent through our Contact &amp; Support page.</p>
      </Sec>
    </InfoLayout>
  );
}
